import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../config/api";

const ResetPassword = () => {
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);

  // Read query params from email link
  const token = query.get("token");
  const username = query.get("username");

  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    if (!token || !username) {
      setNotification({
        type: "error",
        message: "Invalid or expired password reset link.",
      });
    }
  }, [token, username]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      setNotification({ type: "error", message: "All fields are required." });
      return;
    }

    if (newPassword !== confirmPassword) {
      setNotification({
        type: "error",
        message: "Passwords do not match.",
      });
      return;
    }

    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/auth/reset-password`,
        {
          email,
          token,
          newPassword,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      setNotification({
        type: "success",
        message: res.data?.message || "Password has been reset successfully.",
      });

      setTimeout(() => navigate("/"), 2000); // redirect to login after success
    } catch (err) {
      console.error("Reset error:", err.response?.data || err.message);
      const msg = err.response?.data?.message || err.response?.data || "Failed to reset password.";
      setNotification({ type: "error", message: msg });
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <div className="w-full max-w-sm p-6 rounded-lg shadow border border-[#dde1e3] bg-white">
        <h2 className="text-2xl mb-4 font-bold">Reset Password</h2>

        {notification && (
          <div
            className={`mb-4 p-3 rounded ${
              notification.type === "error"
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            {notification.message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="email"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-lg border border-[#dce1e5] bg-white h-12 px-4 text-base text-[#111518] placeholder:text-[#637988] focus:outline-none focus:border-[#1993e5]"
          />

          <input
            type="password"
            placeholder="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="w-full rounded-lg border border-[#dce1e5] bg-white h-12 px-4 text-base text-[#111518] placeholder:text-[#637988] focus:outline-none focus:border-[#1993e5]"
          />

          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="w-full rounded-lg border border-[#dce1e5] bg-white h-12 px-4 text-base text-[#111518] placeholder:text-[#637988] focus:outline-none focus:border-[#1993e5]"
          />

          <button
            type="submit"
            disabled={!token || !username}
            className="bg-black text-white py-3 hover:bg-[#dce1e5] hover:text-black rounded-full font-bold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Reset Password
          </button>

          <Link
            className="bg-[#dce1e5] text-black py-3 hover:bg-black hover:text-white rounded-full font-bold text-center"
            to="/"
          >
            Back to Login
          </Link>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
